import { render, staticRenderFns } from "./Werehouse.vue?vue&type=template&id=a54e39c2"
import script from "./Werehouse.vue?vue&type=script&lang=js"
export * from "./Werehouse.vue?vue&type=script&lang=js"
import style0 from "./Werehouse.vue?vue&type=style&index=0&id=a54e39c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports